import { createContext, FC, ReactElement, useMemo, useState } from 'react'

export type PendingRequestsContextState = {
  pendingRequests: number
  increasePendingRequest: () => void
  decreasePendingRequest: () => void
}

const contextDefaultValues: PendingRequestsContextState = {
  pendingRequests: 0,
  increasePendingRequest: () => undefined,
  decreasePendingRequest: () => undefined,
}

export const PendingRequestsContext = createContext<PendingRequestsContextState>(
  contextDefaultValues
)

type ProviderPorps = {
  children: ReactElement
}

const PendingRequestsContextProvider: FC<ProviderPorps> = ({ children }) => {
  const [pendingRequests, setPendingRequests] = useState<number>(
    contextDefaultValues.pendingRequests
  )

  const value = useMemo(() => {
    const increasePendingRequest = () => {
      setPendingRequests((prev) => prev + 1)
    }

    const decreasePendingRequest = () => {
      setPendingRequests((prev) => (prev > 0 ? prev - 1 : 0))
    }

    return { pendingRequests, increasePendingRequest, decreasePendingRequest }
  }, [pendingRequests])

  return (
    <PendingRequestsContext.Provider value={value}>
      {children}
    </PendingRequestsContext.Provider>
  )
}

export default PendingRequestsContextProvider
